import { render } from "./DestinationBoardView.vue?vue&type=template&id=5b045a6e&scoped=true"
import script from "./DestinationBoardView.vue?vue&type=script&lang=js"
export * from "./DestinationBoardView.vue?vue&type=script&lang=js"

import "./DestinationBoardView.vue?vue&type=style&index=0&id=5b045a6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b045a6e"]])

export default __exports__